import chevronLeft from "@assets/images/chevron-left.svg";
import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGPLogo from "@assets/images/SCGP-color.svg";
import FormSpacer from "@saleor/components/FormSpacer";
import MyTypography from "@saleor/components/MyTypography";
import React from "react";
import { FormattedMessage } from "react-intl";

import useStyles from "../styles";

export interface ResetPasswordSuccessPageFormData {
  email: string;
}

export interface ResetPasswordSuccessPageProps {
  onBack: () => void;
}

const ResetPasswordSuccessPage: React.FC<ResetPasswordSuccessPageProps> = props => {
  const { onBack } = props;

  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <div className={classes.mainPanel}>
        <div className={classes.headTextLogo}>
          <div className={classes.text}>
            <img src={SCGPLogo} alt="SCG Logo" />
          </div>
          <div className={classes.logo}>
            <img src={EOrderingLogo} alt={"logo"} />
          </div>
        </div>
        <MyTypography variant="h5" className={classes.header}>
          <FormattedMessage defaultMessage="Your password reset link has been sent." />
        </MyTypography>
        <MyTypography variant="body3" className={classes.description}>
          <FormattedMessage defaultMessage="If an account with that email address exists, you’ll soon get an email with your password reset link." />
        </MyTypography>
        <FormSpacer space={100} />
        <MyTypography
          className={classes.linkBack}
          onClick={onBack}
          variant="body3"
          data-testid="login-link"
        >
          <img src={chevronLeft} alt="Back to Sign In" />
          <FormattedMessage
            defaultMessage="Back to Sign In"
            description="description"
          />
        </MyTypography>
      </div>
    </div>
  );
};

ResetPasswordSuccessPage.displayName = "ResetPasswordSuccessPage";
export default ResetPasswordSuccessPage;
